var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDeleverage = function SvgDeleverage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "deleverage_svg__deleverage"
  }, /*#__PURE__*/React.createElement("path", {
    id: "deleverage_svg__Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.57122 4.12102C1.94612 3.74612 2.55396 3.74612 2.92886 4.12102L9.00004 10.1922L12.6072 7.78502C12.9469 7.44529 13.4855 7.40902 13.8677 7.70014C16.1459 9.43536 18.9824 13.0789 19.7195 15.8462L19.8958 16.5043L21.9187 13.0008C22.1838 12.5417 22.7709 12.3844 23.2301 12.6495C23.6892 12.9146 23.8465 13.5017 23.5814 13.9609L20.3994 19.4719C20.2721 19.6924 20.0624 19.8533 19.8165 19.9191C19.5705 19.985 19.3085 19.9505 19.088 19.8232L13.577 16.6412C13.1179 16.3761 12.9606 15.789 13.2257 15.3298C13.4908 14.8707 14.0779 14.7134 14.5371 14.9785L18.0413 17.0018L17.8644 16.3409C17.3088 14.2549 14.953 11.185 13.3491 9.75847L9.67886 12.2287C9.49883 12.4087 9.25465 12.5098 9.00004 12.5098C8.74543 12.5098 8.50125 12.4087 8.32122 12.2287L1.57122 5.47867C1.19631 5.10376 1.19631 4.49592 1.57122 4.12102Z",
    fill: "#8061E5"
  }))));
};
export default SvgDeleverage;